import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes = [
  {
    path: '/',
    redirect: '/login'  // 默认跳转到登录页
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false, isAuthPage: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresAuth: false, isAuthPage: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true, showTabBar: true }
  },
  {
    path: '/hall',
    name: 'Hall',
    component: () => import('@/views/Hall.vue'),
    meta: { requiresAuth: true, showTabBar: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true, showTabBar: true }
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('@/views/Service.vue'),
    meta: { requiresAuth: true, showTabBar: true }
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: () => import('@/views/Ranking.vue'),
    meta: { requiresAuth: true, showTabBar: true }
  },
  {
    path: '/agent',
    name: 'Agent',
    component: () => import('@/views/Agent.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/game/:gameId',
    name: 'Game',
    component: () => import('@/views/Game.vue'),
    meta: { requiresAuth: true }
  },
  // 子游戏路由
  {
    path: '/game/ccl',
    name: 'GameCCL',
    component: () => import('@/games/game_ccl/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/game/block',
    name: 'GameBlock',
    component: () => import('@/games/game_block/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/topup',
    name: 'Topup',
    component: () => import('@/views/Topup.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/topup-history',
    name: 'TopupHistory',
    component: () => import('@/views/TopupHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/Withdraw.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw-history',
    name: 'WithdrawHistory',
    component: () => import('@/views/WithdrawHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/balance-log',
    name: 'BalanceLog',
    component: () => import('@/views/BalanceLog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/vip-records',
    name: 'VipRecords',
    component: () => import('@/views/VipRecords.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  // 处理根路径重定向
  if (to.path === '/' || to.path === '') {
    // 邀请链接：/?ref=XXXX → 无论是否登录都先进注册页，注册页内部若已登录会自动跳Home
    if (to.query.ref) {
      next({ name: 'Register', query: { ref: to.query.ref } })
      return
    }
    if (userStore.isLoggedIn) {
      next({ name: 'Home' })
    } else {
      next({ name: 'Login' })
    }
    return
  }
  
  // 如果是登录/注册页面，且已登录，则跳转到首页
  if (to.meta.isAuthPage && userStore.isLoggedIn) {
    next({ name: 'Home' })
    return
  }
  
  // 如果需要登录的页面，检查登录状态
  if (to.meta.requiresAuth) {
    // 检查是否有token（从store或localStorage）
    const token = userStore.token || localStorage.getItem('client_token') || ''
    
    if (!token || !userStore.isLoggedIn) {
      // 未登录，跳转到登录页，并保存目标路径
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else {
      // 已登录，继续访问
      next()
    }
  } else {
    // 不需要登录的页面（登录/注册页），直接访问
    next()
  }
})

export default router

